// import { withTranslation } from "react-i18next";
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';

export default function SideBarMenu() {
    const { t, i18n } = useTranslation(['src_Components_Common_SideBarMenu']);
    const handleLogout = (e) => {
        e.preventDefault();
        window.localStorage.removeItem('info')
        window.localStorage.removeItem('pro_pic')
        localStorage.clear();
        // this.props.history.push('/');
        window.location.href = '/';
    }


    const profileName = () => {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_name')) {
            var name = JSON.parse(localStorage.getItem('pro_name'))
            var pro_name = name.split(' ');
            return (
                <span className="profile_name">{pro_name[0]}</span>
            )
        } else {
            var pro_name = x.first_name.split(' ');
            var profile_name=pro_name[0]
            return (
                <span className="profile_name">{profile_name}</span>
            )
        }
    }

    if (localStorage) {
        const x = JSON.parse(localStorage.getItem('info'))
        if (x.user_type_id === 1) {
            return (
                <UncontrolledDropdown>
                    <DropdownToggle caret style={{ color: '#666', backgroundColor: '#f4f2f0', height: "35px", border: '0px solid #f4f2f0' }}>
                        <img src={require("../../assets/images/Dropdown.png")} height="30px" width="30px" />
                    </DropdownToggle>
                    <DropdownMenu
                        modifiers={{
                            setMaxHeight: {
                                enabled: true,
                                order: 890,
                                fn: (data) => {
                                    return {
                                        ...data,
                                        styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            maxHeight: 500,
                                            left: '-15px'
                                        },
                                    };
                                },
                            },
                            setMinWidth: {
                                enabled: true,
                                order: 890,
                                fn: (data) => {
                                    return {
                                        ...data,
                                        styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            minWidth: 220,
                                            left: '-15px'
                                        },
                                    };
                                },
                            },
                        }}
                    >

                        {/* <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name">{x.first_name}</span>
                    </div>

                    <Link to={{
                        pathname: 'buyer-my-profile'
                    }} className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails">{t('15')}</span>
                    </Link> */}
                        {/* <DropdownItem style={{ paddingLeft: '25px', paddingBottom: '0px' }}> <Link className="color_alt" style={{ fontSize: '15px' }} >{x.first_name}</Link></DropdownItem> */}
                        <DropdownItem style={{ paddingLeft: '25px', paddingTop: '0px' }}> <Link to={'/buyer-my-profile'} className="color_alt" style={{ fontSize: '13px' }}><span style={{ fontSize: '15px' }} ><b>{profileName()}</b></span><br />{t('15')}</Link></DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem header style={{ paddingBottom: '0px', paddingLeft: '25px' }}>{t('33')}</DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/buyer-transaction'} className="color_alt" style={{ fontSize: '13px' }} >{t('34')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/buyer-request-home'} className="color_alt" style={{ fontSize: '13px' }}>{t('20')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/buyer-dashboard'} className="color_alt" style={{ fontSize: '13px' }}>{t('35')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/buyer-favorites'} className="color_alt" style={{ fontSize: '13px' }}>{t('21')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/followers-buyer'} className="color_alt" style={{ fontSize: '13px' }}>{t('36')}</Link></DropdownItem>
                        <DropdownItem> </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/buyer-direct-message-list'} className="color_alt" style={{ fontSize: '13px' }}>{t('22')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/buyer-change-password'} className="color_alt" style={{ fontSize: '13px' }}>{t('6')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'#'} onClick={handleLogout} className="color_alt" style={{ fontSize: '13px' }}>{t('23')}</Link></DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            )
        } else if (x.user_type_id === 2) {
            return (
                <UncontrolledDropdown>
                    <DropdownToggle caret style={{ color: '#666', backgroundColor: '#f4f2f0', height: "35px", border: '0px solid #f4f2f0' }}>
                        <img src={require("../../assets/images/Dropdown.png")} height="30px" width="30px" />
                    </DropdownToggle >
                    <DropdownMenu
                        modifiers={{
                            setMaxHeight: {
                                enabled: true,
                                order: 890,
                                fn: (data) => {
                                    return {
                                        ...data,
                                        styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            maxHeight: 500,
                                        },
                                    };
                                },
                            },
                            setMinWidth: {
                                enabled: true,
                                order: 890,
                                fn: (data) => {
                                    return {
                                        ...data,
                                        styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            minWidth: 220,
                                            left: '-15px'
                                        },
                                    };
                                },
                            },
                        }}
                    >
                        {/* <DropdownItem style={{ paddingLeft: '25px',paddingBottom:'0px' }}> <Link  className="color_alt" style={{ fontSize: '15px' }} >{x.first_name}</Link></DropdownItem> */}
                        <DropdownItem style={{ paddingLeft: '25px', paddingTop: '0px' }}> <Link to={'/seller-edit-profile'} className="color_alt" style={{ fontSize: '13px' }}><span style={{ fontSize: '15px' }} ><b>{profileName()}</b></span><br />{t('15')}</Link></DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem header style={{ paddingLeft: '25px', paddingBottom: '0px', fontSize: '15px' }}> {t('7')}</DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/seller-dashboard'} className="color_alt" style={{ fontSize: '13px' }}>{t('8')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/seller-transaction'} className="color_alt" style={{ fontSize: '13px' }} >{t('37')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/request-home'} className="color_alt" style={{ fontSize: '13px' }}>{t('9')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/service-list'} className="color_alt" style={{ fontSize: '13px' }}>{t('4')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/sales'} className="color_alt" style={{ fontSize: '13px' }}>{t('38')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/my-points'} className="color_alt" style={{ fontSize: '13px' }}>{t('39')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/followers'} className="color_alt" style={{ fontSize: '13px' }}>{t('24')}</Link></DropdownItem>
                        <DropdownItem></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/product-upload'}><button className="sell">{t('40')}</button></Link></DropdownItem>
                        <DropdownItem></DropdownItem>
                        <DropdownItem header style={{ paddingLeft: '25px', paddingBottom: '0px', fontSize: '15px' }}> {t('10')}</DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/seller-buyer-transaction'} className="color_alt remove_underline" style={{ fontSize: '13px' }}>{t('34')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/seller-buyer-request-home'} className="color_alt remove_underline" style={{ fontSize: '13px' }}>{t('20')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/purchase-list'} className="color_alt remove_underline" style={{ fontSize: '13px' }}>{t('35')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/seller-favorites'} className="color_alt" style={{ fontSize: '13px' }}>{t('21')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/seller-followers-buyer'} className="color_alt" style={{ fontSize: '13px' }}>{t('36')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}></DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/seller-buyer-direct-message-list'} className="color_alt" style={{ fontSize: '13px' }}>{t('22')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/seller-change-password'} className="color_alt" style={{ fontSize: '13px' }}>{t('6')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/'} className="color_alt" onClick={handleLogout}>{t('23')}</Link></DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            )
        } else if (x.user_type_id === 3) {
            return (
                <UncontrolledDropdown>
                    <DropdownToggle caret style={{ color: '#666', backgroundColor: '#f4f2f0', height: "35px", border: '0px solid #f4f2f0' }}>
                        <img src={require("../../assets/images/Dropdown.png")} height="30px" width="30px" />
                    </DropdownToggle>
                    <DropdownMenu
                        modifiers={{
                            setMaxHeight: {
                                enabled: true,
                                order: 890,
                                fn: (data) => {
                                    return {
                                        ...data,
                                        styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            maxHeight: 500,
                                        },
                                    };
                                },
                            },
                            setMinWidth: {
                                enabled: true,
                                order: 890,
                                fn: (data) => {
                                    return {
                                        ...data,
                                        styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            minWidth: 220,
                                            left: '-15px'
                                        },
                                    };
                                },
                            },
                        }}
                    >
                        <DropdownItem style={{ paddingLeft: '25px', paddingTop: '0px' }}> <Link to={'/affiliator-my-profile'} className="color_alt" style={{ fontSize: '13px' }}><span style={{ fontSize: '15px' }} ><b>{profileName()}</b></span><br />{t('15')}</Link></DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem header style={{ paddingLeft: '25px', paddingBottom: '0px', fontSize: '15px' }}> {t('1')}</DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-dashboard'} className="color_alt" style={{ fontSize: '13px' }}>{t('8')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-create-service-link'} className="color_alt" style={{ fontSize: '13px' }}>{t('0')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-individual-products'} className="color_alt" style={{ fontSize: '13px' }}>{t('2')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-sales-management'} className="color_alt" style={{ fontSize: '13px' }}>{t('3')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-mlm-tree'} className="color_alt" style={{ fontSize: '13px' }}>{t('19')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-management'} className="color_alt" href="." style={{ fontSize: '13px' }}>{t('5')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-my-points'} className="color_alt" style={{ fontSize: '13px' }}>{t('39')}</Link></DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px', paddingBottom: '0px', fontSize: '15px' }} header> {t('10')}</DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/affiliator-buyer-transaction'} className="color_alt" style={{ fontSize: '13px' }}>{t('34')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/affiliator-buyer-request-home'} className="color_alt" style={{ fontSize: '13px' }}>{t('20')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/affiliator-purchase-list'} className="color_alt" style={{ fontSize: '13px' }}>{t('35')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/affiliator-favorites'} className="color_alt" style={{ fontSize: '13px' }}>{t('21')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-followers-buyer'} className="color_alt" style={{ fontSize: '13px' }}>{t('36')}</Link></DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/affiliator-direct-message-list'} className="color_alt" style={{ fontSize: '13px' }}>{t('22')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}> <Link to={'/affiliator-change-password'} className="color_alt" style={{ fontSize: '13px' }}>{t('6')}</Link></DropdownItem>
                        <DropdownItem style={{ paddingLeft: '25px' }}><Link to={'/'} onClick={handleLogout} className="color_alt" style={{ fontSize: '13px' }}>{t('23')}</Link></DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            )
        }
    }
}


 // SideBarMenu = withTranslation('src_Components_Common_SideBarMenu')(SideBarMenu);
